// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { ml } from 'styled-components-spacing';
import Logo from '@images/logo.svg';
import YapitaHealth from '@images/yapitahealth.svg';

export const StyledLogoWrapper = styled.a`
  ${ml(3)}

  flex: 0 0 auto;
  height: 24px;

  cursor: pointer;

  ${breakpoint('desktop')`
    ${ml(3)}
    margin-bottom: 10px;
    height: 30px;
  `}
  ${breakpoint('largeDesktop')`
    ${ml(5)}
  `}
`;

export const StyledLogo = styled(Logo)`
  width: 140px;

  ${breakpoint('desktop')`
    width: 180px;
  `}
`;

export const StyledHeroLogo = styled(YapitaHealth)`
 width: 140px;

${breakpoint('desktop')`
  width: 200px;
`}
`;
